import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ResponseDocumentSubtype, SUBTYPE_OTHER_NAME } from '../../models/response-document-subtype';

@Component({
  selector: 'app-file-subtype-tag-selector',
  standalone: true,
  templateUrl: './file-subtype-tag-selector.component.html',
  styleUrls: ['./file-subtype-tag-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule],
})
export class FileSubtypeTagSelectorComponent implements OnChanges {
  @Input() options: ResponseDocumentSubtype[] = [];
  @Input() value: string | null = null;
  readonly optionSelected = output<ResponseDocumentSubtype>();
  readonly customSelected = output<string>();

  @ViewChild('customInput') set customInputRef(el: ElementRef<HTMLInputElement> | undefined) {
    el?.nativeElement.focus();
  }

  readonly showCustomInput = signal(false);
  readonly customValue = signal('');

  get selectableOptions(): ResponseDocumentSubtype[] {
    return this.options.filter(o => o.name !== SUBTYPE_OTHER_NAME);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['options'] || changes['value']) {
      const isKnown = this.selectableOptions.some(o => o.displayedName === this.value);
      const isCustom = !!this.value && !isKnown;
      this.showCustomInput.set(isCustom);
      if (isCustom) {
        this.customValue.set(this.value ?? '');
      }
    }
  }

  select(option: ResponseDocumentSubtype): void {
    this.showCustomInput.set(false);
    this.customValue.set('');
    this.optionSelected.emit(option);
  }

  openCustomInput(): void {
    this.showCustomInput.set(true);
    this.customValue.set('');
  }

  confirmCustom(): void {
    const trimmed = this.customValue().trim();
    if (!trimmed) return;
    this.customSelected.emit(trimmed);
  }

  onCustomKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') this.confirmCustom();
    if (event.key === 'Escape') {
      this.showCustomInput.set(false);
      this.customValue.set('');
    }
  }
}
